import { setImageElementAlt } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { getLobbyImagePath } from '../../../../../shared/scripts/ui_utils/Utils.ts';
export class UIMHeaderProfileController {
    updateMembershipIcon(userState) {
        const currentMembership = userState.items.getCurrentMembership();
        if (currentMembership != undefined) {
            UIMHeaderProfileController.updateIcon(currentMembership.image, this.playerMembershipIcon);
            this.playerMembershipIcon.classList.remove('hidden');
            if (currentMembership.pending) this.playerMembershipIcon.style.filter = 'grayscale(1)';
        }
    }
    static updateIcon(icon, element) {
        const path = getLobbyImagePath(icon);
        element.src = path;
        setImageElementAlt(element, icon);
    }
    constructor(){
        this.playerMembershipIcon = document.getElementById('header-profile-membership-icon');
    }
}
